import { render, staticRenderFns } from "./GerenciaContasReceber.vue?vue&type=template&id=3a88b768&scoped=true&"
import script from "./GerenciaContasReceber.vue?vue&type=script&lang=js&"
export * from "./GerenciaContasReceber.vue?vue&type=script&lang=js&"
import style0 from "./GerenciaContasReceber.vue?vue&type=style&index=0&id=3a88b768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88b768",
  null
  
)

export default component.exports